import * as activityCounters from '@wix/auto_sdk_activity-counters_activity-counters';

export { activityCounters };
